export default "__VITE_ASSET__B3$h78vn__"